module.exports = __webpack_public_path__ + "media/your_career_track/personal-chef-8a3eb609.png";